import vehiclesSaga from './vehiclesSaga';

export default vehiclesSaga;
